module.exports = __webpack_public_path__ + "img/icon.f8a9e123.png";